import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const forkliftoperatorsAdapter = getAdapter();
const forkliftoperatorsSlice = createSlice({
  name: 'forkliftoperators',
  initialState: forkliftoperatorsAdapter.getInitialState(),
  reducers: {
    setForkliftOperators: (state, { payload: { forkliftoperators } }) => {
      forkliftoperatorsAdapter.setAll(state, forkliftoperators);
    }
  }
});

const selectors = forkliftoperatorsAdapter.getSelectors(({ forkliftoperators }) => forkliftoperators);

export const getForkliftOperatorsIncludingDeleted = state => selectors.selectAll(state);

export const getForkliftOperators = state => getForkliftOperatorsIncludingDeleted(state).filter(({ active }) => active);

export const { setForkliftOperators } = forkliftoperatorsSlice.actions;

export default forkliftoperatorsSlice.reducer;
